const messages = {
  es: {
    translations: {
      newTicketOficial: {
        createAndSend: "Crear y Enviar Plantilla",
      },
      qrcodeModal: {
        title: "Conectar a WhatsApp",
        subtitle: "Escanea el código QR con tu celular para iniciar la sesión",
        connected: "✅ ¡Conectado exitosamente!",
        generating: "Generando nuevo código QR...",
        step1a: "Abre ",
        step1b: " en tu celular",
        step2a: "Toca en ",
        step2options: "Más opciones ⋮",
        step2b: " o ",
        step2settings: "Configuración ⚙",
        step2c: " y selecciona ",
        step2linked: "Dispositivos conectados",
        step3a: "Toca en ",
        step3link: "Conectar un dispositivo",
        step3b: " y apunta la cámara hacia este código QR",
        refreshing: "Actualizando código QR...",
        refreshIn: "El código QR se actualiza en {{seconds}}s",
      },
      ticketActionButtons: {
        windowExpiredTooltip: "⚠️ Ventana de 24h expirada - Envía una Plantilla para reabrir la conversación",
        sendTemplateTooltip: "Enviar Plantilla (API Oficial)",
        sendTemplateExpired: "Enviar Plantilla (ventana expirada)",
        sendTemplate: "Enviar Plantilla",
      },
      templateMetaModal: {
        title: "Plantillas de WhatsApp",
        selectedTitle: "Detalles de la Plantilla Seleccionada",
        name: "Nombre",
        content: "Contenido",
        language: "Idioma",
        category: "Categoría",
        body: "CUERPO",
        required: "Campo requerido",
        back: "Volver",
        send: "Enviar Plantilla",
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas rápidas",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        noPhone: "No hay teléfono disponible para copiar",
        copyError: "Error al copiar el teléfono",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          disabled:
            "El registro de usuarios está deshabilitado en este momento. Por favor, inténtalo más tarde.",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "Regístrate",
          forgotPassword: "Olvidé mi contraseña",
        },
        footer: { rights: "Todos los derechos reservados." },
      },
      templateManager: {
        title: "Gestión de Plantillas",
        connection: "Conexión",
        search: "Buscar...",
        syncTooltip: "Sincronizar con Meta",
        sync: "Sync",
        createTemplate: "Crear Plantilla",
        noConnection: "No se encontró conexión de API Oficial. Agrega una conexión oficial para gestionar plantillas.",
        noTemplates: 'No se encontraron plantillas. Haz clic en "Sync" para sincronizar o en "Crear Plantilla" para crear una nueva.',
        table: { name: "Nombre", category: "Categoría", language: "Idioma", status: "Estado", actions: "Acciones" },
        tooltips: { view: "Ver detalles", edit: "Editar (recrear plantilla)", delete: "Eliminar plantilla" },
        categories: { marketing: "Marketing", utility: "Utilidad", authentication: "Autenticación" },
        deleteModal: {
          title: "¿Eliminar plantilla",
          body: "Esta acción eliminará la plantilla en Meta y localmente. ¿Deseas continuar?",
        },
        viewModal: {
          close: "Cerrar",
          title: "Detalles de la Plantilla",
          name: "Nombre",
          language: "Idioma",
          status: "Estado",
          category: "Categoría",
          components: "Componentes",
        },
        createModal: {
          title: "Crear Nueva Plantilla",
          templateName: "Nombre de la Plantilla",
          templateNameHelper: "Solo letras minúsculas, números y _",
          category: "Categoría",
          language: "Idioma",
          header: "Encabezado (opcional)",
          headerHelper: "Texto que se muestra en la parte superior de la plantilla",
          body: "Cuerpo del Mensaje",
          bodyHelper: "Usa {1}, {2}, etc. para variables. Ej: Hola {1}, tu pedido {2} está listo!",
          footer: "Pie de página (opcional)",
          footerHelper: "Texto pequeño al final de la plantilla",
          buttonsTitle: "Botones (opcional - máx 3)",
          quickReply: "+ Respuesta Rápida",
          urlButton: "+ Enlace",
          phoneButton: "+ Teléfono",
          chipQuickReply: "Resp. Rápida",
          chipUrl: "Enlace",
          chipPhone: "Teléfono",
          textLabel: "Texto",
          urlLabel: "URL",
          phoneLabel: "Teléfono",
          preview: "Vista previa",
          buttonPlaceholder: "Botón {{index}}",
          previewEmpty: "Empieza a escribir el cuerpo para ver la vista previa aquí",
          examplesTitle: "Ejemplos de variables (requerido por Meta)",
          examplesSubtitle: "Meta requiere un valor de ejemplo para cada variable para que los revisores sepan qué contenido irá allí.",
          exampleFor: "ejemplo para",
          cancel: "Cancelar",
          submit: "Enviar para Aprobación",
          submitting: "Enviando...",
        },
        validation: {
          nameAndBodyRequired: "El nombre y el cuerpo del mensaje son obligatorios",
          examplesRequired: "Debes ingresar un ejemplo para:",
        },
        toast: {
          approved: '¡La plantilla "{{name}}" fue APROBADA por Meta! 🎉',
          rejected: 'La plantilla "{{name}}" fue RECHAZADA por Meta',
          statusChange: 'Plantilla "{{name}}": {{old}} → {{new}}',
          syncDone: "Sincronización completa - {{count}} plantilla(s) con cambio de estado",
          syncNoChanges: "Plantillas sincronizadas - sin cambios de estado",
          tokenExpired: "⚠️ Token de API Oficial expirado o inválido. Actualiza el token de acceso de Meta en la configuración de la conexión.",
          submitted: "Plantilla enviada para aprobación de Meta",
          deleted: "Plantilla eliminada correctamente",
        },
        status: {
          approved: "Aprobado",
          rejected: "Rechazado",
          pending: "Pendiente",
          paused: "Pausado",
        },
      },
      flowBuilder: {
        title: "Editor de Flujos",
        addNodes: "Agregar Nodos",
        saveFlow: "Guardar Flujo",
        startOfFlow: "Inicio del flujo",
        intervalLabel: "Intervalo {{sec}} seg.",
        toast: {
          saved: "Flujo guardado con éxito",
          saveError: "Error al guardar el flujo",
        },
        categories: {
          basic: "Básicos",
          content: "Contenido",
          interaction: "Interacción",
          logic: "Lógica",
          system: "Sistema",
          integrations: "Integraciones",
        },
        nodes: {
          start: { name: "Inicio", description: "Punto inicial del flujo" },
          content: { name: "Contenido", description: "Enviar texto, imagen, audio o video" },
          text: { name: "Texto", description: "Mensaje de texto simple" },
          menu: { name: "Menú", description: "Menú numérico de opciones" },
          interactiveMenu: { name: "Msg Interactiva API", description: "Botones y listas (Baileys)" },
          input: { name: "Input", description: "Recopilar entrada del usuario" },
          interval: { name: "Intervalo", description: "Pausar ejecución por tiempo" },
          random: { name: "Aleatorizador", description: "Elección aleatoria de caminos" },
          conditionCompare: { name: "Si/No (If/Else)", description: "Bifurcar flujo según condición" },
          ticket: { name: "Filas", description: "Gestionar filas de atención" },
          tag: { name: "Etiquetas", description: "Agregar etiquetas al contacto" },
          removeTag: { name: "Quitar Etiqueta", description: "Quitar etiquetas del contacto" },
          switchFlow: { name: "Cambiar Flujo", description: "Dirigir a otro flujo" },
          attendant: { name: "Agente", description: "Transferir a agente" },
          httpRequest: { name: "HTTP Request", description: "Solicitud HTTP externa" },
          variable: { name: "Variable", description: "Definir variables globales" },
          gemini: { name: "Gemini", description: "Integración con Gemini" },
          openai: { name: "OpenAI", description: "Integración con OpenAI" },
          claude: { name: "Claude", description: "Integración con Claude (Anthropic)" },
        },
        aiModal: {
          addTitle: "Agregar {{provider}} al flujo",
          editTitle: "Editar {{provider}} del flujo",
          buttons: { add: "Agregar", save: "Guardar", cancel: "Cancelar" },
          basicSettings: "Configuraciones Básicas - {{provider}}",
          assistantName: "Nombre del Asistente",
          apiKey: "API Key {{provider}}",
          model: "Modelo {{provider}}",
          systemPrompt: "Prompt del Sistema",
          systemPromptPlaceholder: "Describe cómo debe comportarse la IA, qué información debe recopilar, cómo debe responder...",
          sendWelcomeMessage: "Enviar saludo automático al activarse",
          sendWelcomeMessageHelper: "Se envía apenas se activa este nodo (\"¡Hola! Soy [nombre del asistente]...\"). Desactívalo si tu flujo ya envía su propio saludo antes de llegar acá.",
          temperature: "Temperatura",
          temperatureHelper: "0 = conservador, 2 = creativo",
          maxTokens: "Max Tokens",
          maxTokensHelper: "Tamaño máximo de la respuesta",
          maxMessages: "Max Mensajes",
          maxMessagesHelper: "Historial de contexto",
          voiceSettings: "Configuraciones de Voz (Opcional)",
          responseType: "Tipo de Respuesta",
          textOnly: "Solo Texto",
          voiceKeyAzure: "Voice Key (Azure)",
          voiceKeyPlaceholder: "Clave del Azure Speech Service",
          voiceRegionAzure: "Voice Region (Azure)",
          voiceRegionPlaceholder: "ej: brazilsouth",
          flowBehavior: "Comportamiento del Flujo",
          flowBehaviorTooltip: "Configura cómo debe comportarse {{provider}} en el flujo",
          operatingMode: "Modo de Funcionamiento",
          permanentLabel: "Permanente",
          permanentDesc1: "- Terminar flujo aquí",
          permanentDesc2: "El usuario sigue conversando con la IA hasta pedir transferencia o finalizar",
          temporaryLabel: "Temporal",
          temporaryDesc1: "- Vuelve al flujo después",
          temporaryDesc2: "La IA ejecuta una tarea específica y luego regresa al flujo normal",
          temporarySettingsTitle: "⏱️ Configuraciones del Modo Temporal",
          temporarySettingsSubtitle: "Configura cuándo la IA debe detenerse y regresar al flujo",
          maxInteractions: "Máximo de Interacciones",
          maxInteractionsHelper: "Número máximo de mensajes antes de volver al flujo (0 = ilimitado)",
          timeoutMinutes: "Timeout (minutos)",
          timeoutHelper: "Tiempo límite antes de volver al flujo (0 = sin límite)",
          continueKeywordsTitle: "Palabras clave para Continuar Flujo",
          continueKeywordsPlaceholder: "Escribe una palabra clave",
          addKeywordButton: "Agregar",
          continueKeywordsHelper: "Cuando el usuario envíe una de estas palabras, el flujo continuará automáticamente",
          objective: "Objetivo de la IA",
          objectiveHelper: "Describe qué debe completar la IA (ej: 'Recopilar nombre, email y teléfono')",
          objectivePlaceholder: "Ej: Recopilar datos del cliente, Calificar interés, Diagnosticar problema...",
          autoComplete: "Auto completar al alcanzar el objetivo",
          autoCompleteHelper: "La IA analizará automáticamente si completó el objetivo y volverá al flujo",
          transferQueueId: "ID de la Fila (para transferencia)",
          transferQueueHelper: "ID de la fila a donde transferir si el usuario pide un agente (0 = no transferir)",
          validation: {
            tooShort: "¡Muy corto!",
            tooLong: "¡Muy largo!",
            required: "Obligatorio",
            promptRequired: "Describe el entrenamiento para la Inteligencia Artificial",
            invalidModel: "Modelo inválido",
            modelRequired: "Indica el modelo",
            minTokens: "Mínimo 10 tokens",
            maxTokensLimit: "Máximo {{max}} tokens",
            tokensRequired: "Indica el número máximo de tokens",
            minTemp: "Mínimo 0",
            maxTemp: "Máximo 2",
            temperatureRequired: "Indica la temperatura",
            apiKeyRequired: "Indica la API Key",
            minMessages: "Mínimo 1 mensaje",
            maxMessagesLimit: "Máximo 100 mensajes",
            messagesRequired: "Indica el número máximo de mensajes",
            voiceRequired: "Indica el modo de Voz",
            voiceKeyRequired: "Voice Key es obligatoria para síntesis de voz",
            voiceRegionRequired: "Voice Region es obligatoria para síntesis de voz",
            invalidFlowMode: "Modo de flujo inválido",
            flowModeRequired: "Selecciona el modo de flujo",
            minInteractions: "Mínimo 1 interacción",
            maxInteractionsLimit: "Máximo 50 interacciones",
            minTimeout: "Mínimo 1 minuto",
            maxTimeoutLimit: "Máximo 60 minutos",
            keywordEmpty: "La palabra clave no puede estar vacía",
            keywordsRequired: "Se requiere al menos una palabra clave en modo temporal",
            objectiveRequired: "El objetivo es obligatorio cuando auto completar está activo",
          },
        },
        nodeLabels: {
          startDescription: "¡Este bloque marca el inicio de tu flujo!",
          message: "Mensaje",
          image: "Imagen",
          audio: "Audio",
          video: "Video",
          recordedNow: "Grabado en el momento",
          audioSent: "Audio enviado",
          noHtml5Support: "tu navegador no soporta HTML5",
          seconds: "{{sec}} segundos",
          secondsWord: "segundos",
          numericMenu: "Menú Numérico",
          tag: "Etiqueta",
          tagNotSelected: "Etiqueta no seleccionada",
          removeTagDescription: "Quita la etiqueta del contacto",
          switchFlow: "Cambiar Flujo",
          queue: "Fila",
          globalVariable: "Variable Global",
          variableNameLabel: "Nombre de la variable",
          valueLabel: "Valor",
          variableValueHelper: "Puedes usar valores estáticos o referencias como ${otraVariable}",
          saved: "¡Guardado!",
          saveVariableButton: "Guardar variable",
          variableSavedSuccess: "¡Variable guardada con éxito!",
          ifElse: "Si / No",
          and: "Y",
          or: "O",
          true: "Verdadero",
          false: "Falso",
          field: "campo",
          value: "valor",
          question: "Pregunta:",
          questionNotDefined: "Pregunta no definida",
          variableToStoreAnswer: "Variable para almacenar la respuesta:",
          variableNotDefined: "Variable no definida",
          valueTooltip: "Valor: {{value}}",
          usingVariables: "Usando variables: {{vars}}",
          alwaysAsk: "Siempre preguntar (aunque la variable ya exista)",
          buttons: "Botones",
          bodyPlaceholder: "Cuerpo del mensaje...",
          buttonDefault: "Botón {{number}}",
          selectDefault: "Seleccionar",
          itemDefault: "Ítem {{number}}",
          operators: {
            equals: "==",
            notEquals: "≠",
            contains: "∈ contiene",
            notContains: "∉ no contiene",
            containsAny: "∈… contiene alguno",
            greaterThan: ">",
            lessThan: "<",
            greaterOrEqual: "≥",
            lessOrEqual: "≤",
            startsWith: "⊰ empieza con",
            endsWith: "⊱ termina con",
            isEmpty: "∅ vacío",
            isNotEmpty: "¬∅ no vacío",
            regex: ".* regex",
          },
        },
        httpRequest: {
          title: "Solicitud HTTP",
          presetsTitle: "Webhooks Preconfigurados",
          selectPreset: "Seleccionar preset",
          selectPresetPlaceholder: "Elige una configuración lista...",
          systemChip: "SISTEMA",
          usingPreset: "Usando preset: ",
          removeButton: "Quitar",
          url: "URL",
          urlFromPreset: "URL (del preset)",
          urlHelperPreset: "Puedes editar la URL base del preset si es necesario",
          method: "Método",
          testRequest: "Probar Solicitud",
          apiResponse: "Respuesta de la API:",
          viewFullResponse: "Ver respuesta completa",
          showAdvanced: "Mostrar avanzado",
          hideAdvanced: "Ocultar avanzado",
          advancedOverridePresetWarning: "Las configuraciones avanzadas pueden sobrescribir la configuración del preset",
          timeoutMs: "Timeout (ms)",
          queryParams: "Parámetros de Query",
          key: "Clave",
          value: "Valor",
          addParam: "Agregar Parámetro",
          headersJson: "Encabezados (JSON)",
          requestBodyJson: "Cuerpo de la solicitud (JSON)",
          editRequestBody: "Editar cuerpo de la solicitud",
          close: "Cerrar",
          hideMapping: "Ocultar Variables de la Respuesta",
          mapResponseVariables: "Mapear Variables de la Respuesta",
          mapResponseVariablesTitle: "Mapear datos de la respuesta a variables",
          path: "Ruta",
          pathPlaceholder: "ej: data.user.id",
          variableName: "Nombre de la variable",
          variableNamePlaceholder: "ej: userId",
          addVariable: "Agregar variable",
          usefulTips: "Consejos útiles:",
          apiResponseAutoSaved: "La respuesta completa de la API se guarda automáticamente en la variable global",
          variableUsageTip: "Puedes usar ${nombreDeVariable} en la URL y el cuerpo de la solicitud para incluir valores de variables.",
          fullResponseTitle: "Respuesta completa de la API",
          configSaved: "¡Configuración guardada!",
          requestError: "Error en la solicitud",
        },
        modals: {
          text: {
            addTitle: "Agregar mensaje al flujo",
            editTitle: "Editar mensaje del flujo",
            add: "Agregar",
            save: "Guardar",
            messageLabel: "Mensaje",
          },
          interval: {
            addTitle: "Agregar un intervalo al flujo",
            editTitle: "Editar intervalo",
            add: "Agregar",
            edit: "Editar",
            secondsLabel: "Tiempo en segundos",
            toastMissingValue: "Agrega el valor del intervalo",
            toastMaxTime: "Tiempo máximo alcanzado: 120 segundos",
          },
          image: {
            addTitle: "Agregar imagen al flujo",
            editTitle: "Editar imagen",
            add: "Agregar",
            save: "Guardar",
            captionLabel: "Leyenda (opcional)",
            uploadButton: "Subir imagen",
            toastAdded: "¡Imagen agregada con éxito!",
            toastFileTooBig: "¡Archivo demasiado grande! 2MB máximo",
          },
          audio: {
            addTitle: "Agregar audio al flujo",
            editTitle: "Editar audio",
            add: "Agregar",
            save: "Guardar",
            captionLabel: "Leyenda (opcional)",
            uploadButton: "Subir audio",
            sendAsRecorded: "Enviar como audio grabado en el momento",
            toastAdded: "¡Audio agregado con éxito!",
            toastFileTooBig: "¡Archivo demasiado grande! 5MB máximo",
          },
          video: {
            addTitle: "Agregar video al flujo",
            editTitle: "Editar video",
            add: "Agregar",
            save: "Guardar",
            captionLabel: "Leyenda (opcional)",
            uploadButton: "Subir video",
            mp4OnlyWarning: "¡ATENCIÓN! ¡Solo videos en MP4!",
            toastAdded: "¡Video agregado con éxito!",
            toastFileTooBig: "¡Archivo demasiado grande! 20MB máximo",
          },
          tag: {
            addTitle: "Agregar una etiqueta al flujo",
            editTitle: "Editar etiqueta",
            add: "Agregar",
            edit: "Editar",
            chooseTag: "Elige una etiqueta",
            selectTag: "Selecciona una etiqueta",
            noTagSelected: "Ninguna etiqueta seleccionada",
            toastMissing: "Agrega una etiqueta",
          },
          removeTag: {
            addTitle: "Quitar una etiqueta del flujo",
            editTitle: "Editar eliminación de etiqueta",
            add: "Agregar Eliminación",
            edit: "Editar",
            chooseTagToRemove: "Elige una etiqueta para quitar del contacto",
            description: "Esta acción quitará la etiqueta seleccionada del contacto cuando el flujo se ejecute",
            selectTagToRemove: "Selecciona una etiqueta para quitar",
            noTagSelected: "Ninguna etiqueta seleccionada",
            toastMissing: "Selecciona una etiqueta para quitar",
          },
          switchFlow: {
            addTitle: "Agregar Cambio de Flujo",
            editTitle: "Editar Cambio de Flujo",
            add: "Agregar",
            edit: "Editar",
            chooseFlowPlaceholder: "Elige un flujo",
          },
          attendant: {
            addTitle: "Agregar un agente al flujo",
            editTitle: "Editar agente",
            add: "Agregar",
            edit: "Editar",
            chooseAgent: "Elige un agente",
            selectUser: "Selecciona un usuario",
            toastMissing: "Agrega un agente",
          },
          ticket: {
            addTitle: "Agregar una fila al flujo",
            editTitle: "Editar fila",
            add: "Agregar",
            edit: "Editar",
            chooseQueue: "Elige la fila a la que deseas transferir",
            selectConnection: "Selecciona una Conexión",
            toastMissing: "Agrega una fila",
          },
          menu: {
            addTitle: "Agregar menú al flujo",
            editTitle: "Editar menú",
            add: "Agregar",
            save: "Guardar",
            explanationLabel: "Mensaje de explicación del menú",
            addOption: "Agregar Opción",
            typeOption: "Escribe {{number}}",
            optionPlaceholder: "Escribe la opción",
          },
          randomizer: {
            addTitle: "Agregar un aleatorizador al flujo",
            editTitle: "Editar aleatorizador",
            add: "Agregar",
            edit: "Editar",
            toastMissingValue: "Agrega el valor del intervalo",
            toastMaxTime: "Tiempo máximo alcanzado: 120 segundos",
          },
          input: {
            addTitle: "Agregar input al flujo",
            editTitle: "Editar input del flujo",
            add: "Agregar",
            saveChanges: "Guardar cambios",
            questionLabel: "Pregunta",
            questionTooltip: "La pregunta que se enviará al usuario. Puedes incluir variables usando ${nombreVariable}",
            questionInputLabel: "Escribe la pregunta",
            questionPlaceholder: "Ej: Hola {{firstName}}, ¿cuál es tu edad?",
            flowVariablesLabel: "Variables de flujo (haz clic para insertar):",
            variableNameLabel: "Nombre de la variable",
            variableNameTooltip: "Nombre de la variable donde se almacenará la respuesta. No uses espacios ni caracteres especiales.",
            variableNamePlaceholder: "Ej: edad_cliente",
            variableNameHelper: "La respuesta del usuario se almacenará en esta variable",
            howItWorksTitle: "Cómo funciona",
            howItWorksDescription: "Este nodo enviará la pregunta al usuario y esperará una respuesta. Cuando el usuario responda, el valor se almacenará en la variable especificada y el flujo continuará al siguiente nodo.",
          },
          flowModal: {
            validation: {
              tooShort: "¡Muy corto!",
              tooLong: "¡Muy largo!",
              nameRequired: "¡Escribe un nombre!",
            },
          },
          interactive: {
            addTitle: "Mensaje Interactivo (Baileys)",
            editTitle: "Editar Mensaje Interactivo",
            add: "Agregar",
            save: "Guardar",
            cancel: "Cancelar",
            bodyRequired: "¡El cuerpo del mensaje es obligatorio!",
            addAtLeastOneOption: "¡Agrega al menos una opción!",
            imageUploadError: "Error al subir la imagen",
            fileTooBig: "¡Archivo demasiado grande! Máximo 2MB",
            maxOptionsWarning: "¡Límite máximo de {{max}} opciones para botones!",
            preview: "Vista previa",
            messageType: "Tipo de mensaje interactivo",
            buttonsMax3: "Botones (máx. 3)",
            infoBanner: "Botones interactivos vía Baileys (nativeFlowMessage). Funciona en conexiones no oficiales. Límite de 3 botones.",
            contentTab: "CONTENIDO DEL MENSAJE",
            buttonsTab: "BOTONES ({{count}}/{{max}})",
            bodyLabel: "Cuerpo del mensaje",
            footerLabel: "Pie de página (opcional)",
            headerImageLabel: "Imagen de encabezado (opcional)",
            changeImage: "Cambiar imagen",
            uploadImage: "Subir imagen",
            listButtonTextLabel: "Texto del botón de la lista",
            listButtonTextHelper: "Texto que se muestra en el botón que abre la lista",
            optionsButtons: "Botones",
            optionsList: "Opciones de la lista",
            addButton: "Agregar",
            addAtLeastOneOptionWarning: "⚠ Agrega al menos una opción.",
            buttonTextPlaceholder: "Texto del botón {{number}}",
            optionPlaceholder: "Opción {{number}}",
          },
          conditionCompare: {
            operators: {
              equals: "Igual a",
              notEquals: "Diferente de",
              contains: "Contiene texto",
              notContains: "No contiene",
              containsAny: "Contiene cualquiera (,)",
              startsWith: "Empieza con",
              endsWith: "Termina con",
              greaterThan: "Mayor que",
              lessThan: "Menor que",
              greaterOrEqual: "Mayor o igual a",
              lessOrEqual: "Menor o igual a",
              isEmpty: "Está vacío",
              isNotEmpty: "No está vacío",
              regex: "Expresión regular",
            },
            operatorGroups: {
              Igualdade: "Igualdad",
              Texto: "Texto",
              "Numérico": "Numérico",
              Estado: "Estado",
              "Avançado": "Avanzado",
            },
            categories: {
              "Contato": "Contacto",
              "Ticket": "Ticket",
              "Variável Global": "Variable Global",
              "Input Capturado": "Input Capturado",
              "Menu": "Menú",
              "HTTP / API": "HTTP / API",
              "API": "API",
            },
            staticVars: {
              contactName: "Nombre del contacto",
              contactEmail: "Email del contacto",
              contactPhone: "Teléfono / número del contacto",
              lastMessage: "Último mensaje recibido",
              ticketId: "ID del ticket actual",
              ticketStatus: "Estado del ticket (open/pending/closed)",
              ticketQueue: "Fila actual del ticket",
              apiResponse: "Respuesta de la última solicitud HTTP",
            },
            dynamicVarDesc: {
              globalVariableValue: 'Valor: "{{value}}"',
              globalVariableGeneric: "Variable global del flujo",
              inputAnswerFrom: 'Respuesta de: "{{label}}"',
              inputAnswerGeneric: "Respuesta capturada del usuario",
              menuResponse: 'Respuesta del menú: "{{message}}"',
              menuOption: 'Opción [{{number}}] del menú: "{{value}}"',
              httpMappedFrom: "Mapeado de: {{path}}",
              httpResponseVar: "Variable de la respuesta HTTP",
            },
            titleEdit: "Editar Condición",
            titleNew: "Nueva Condición",
            fieldLabel: "Variable / Campo",
            fieldPlaceholder: "Escribe $ para ver variables disponibles",
            fieldHelper: "Escribe $ para autocompletar variables del flujo",
            insertVariableTooltip: "Insertar variable con el selector",
            conditionTypeLabel: "Tipo de condición",
            comparisonValueLabel: "Valor de la comparación",
            commaValuesLabel: "Valores separados por coma",
            commaPlaceholder: "si, s, yes, 1",
            regexHelper: "Ej: ^[0-9]{11}$ — expresión regular JavaScript",
            containsAnyHelper: "Cualquier token de la lista dispara Verdadero",
            valueHelper: "Valor fijo o variable con $",
            and: "Y (AND)",
            or: "O (OR)",
            addCondition: "Agregar condición",
            logicAllTrue: "TODAS las condiciones",
            logicAnyTrue: "CUALQUIER condición",
            logicPrefix: "Lógica: Verdadero si",
            logicSuffix: "sean satisfechas",
            quickTipsTitle: "💡 Consejos rápidos",
            tip1: "Contiene cualquiera (,): separa tokens por coma → sim, s, yes, 1",
            tip2: "Regex: usa expresión JS → ^[0-9]{11}$ para validar documento",
            tip3: "Usa ${variable} en cualquier campo para referenciar valores dinámicos",
            saveError: "Ocurrió un error al guardar. Inténtalo de nuevo.",
            conditionFieldRequired: 'Condición {{number}}: el campo "Variable / Campo" es obligatorio',
            conditionValueRequired: 'Condición {{number}}: el campo "Valor de la comparación" es obligatorio',
            cancel: "Cancelar",
            saving: "Guardando...",
            saveChanges: "Guardar cambios",
            add: "Agregar",
            selectVariable: "Seleccionar variable",
            varsFoundInFlow: "{{count}} variable(s) encontrada(s) en el flujo",
            addVarNodesHint: "Agrega nodos de Variable Global o Input para variables dinámicas",
            searchVariablePlaceholder: "Buscar variable...",
            noVariableFound: "Ninguna variable encontrada",
            flowVariablesTitle: "Variables del flujo",
          },
          singleBlock: {
            addTitle: "Agregar contenido al flujo",
            editTitle: "Editar contenido",
            add: "Agregar",
            save: "Guardar",
            toastEmptyMessage: "¡Campos de mensaje vacíos!",
            toastIntervalRange: "¡El intervalo no puede ser 0 ni mayor que 120!",
            toastImageTooBig: "¡Archivo demasiado grande! 2MB máximo",
            toastAudioTooBig: "¡Archivo demasiado grande! 5MB máximo",
            toastVideoTooBig: "¡Archivo demasiado grande! 20MB máximo",
            toastDocumentTooBig: "¡Archivo demasiado grande! 10MB máximo",
            toastContentAdded: "¡Contenido agregado con éxito!",
            toastDeleteEmptyCards: "Elimina las tarjetas vacías (Imagen, Audio y Video)",
            documentLabel: "Documento",
            uploadDocument: "Subir Documento",
            viewDocument: "Ver Documento",
            availableVariables: "Variables disponibles",
            uploadingContent: "Subiendo los archivos y creando el contenido...",
            variableLabels: {
              firstName: "Primer Nombre",
              name: "Nombre",
              userName: "Agente",
              ms: "Saludo",
              protocol: "Protocolo",
              date: "Fecha",
              hour: "Hora",
              ticket_id: "Nº de Ticket",
              queue: "Sector",
              connection: "Conexión",
              phoneNumber: "Teléfono",
              email: "Correo",
              kanban: "Kanban",
            },
          },
        },
      },
      flowBuilderList: {
        title: "Flujos de Conversación ({{count}})",
        searchPlaceholder: "Buscar flujos...",
        importButton: "Importar (.zip)",
        newFlowButton: "Nuevo Flujo",
        emptyTitleSearch: "Ningún flujo encontrado",
        emptyTitleNoFlows: "Aún no has creado ningún flujo",
        emptyDescSearch: "Intenta usar otros términos de búsqueda",
        emptyDescNoFlows: "Crea tu primer flujo de conversación para automatizar la atención",
        createFirstFlow: "Crear Primer Flujo",
        createFlowAriaLabel: "Crear flujo",
        menu: {
          export: "Exportar (.zip)",
          open: "Abrir flujo",
          edit: "Editar flujo",
          delete: "Eliminar flujo",
        },
        deleteTitle: 'Eliminar flujo "{{name}}"?',
        deleteBody: "Esta acción no se puede deshacer. Se perderán todas las integraciones relacionadas.",
        duplicateTitle: 'Duplicar flujo "{{name}}"?',
        duplicateBody: "Se creará una copia del flujo para que la edites.",
        toast: {
          activated: "activado",
          deactivated: "desactivado",
          toggled: "Flujo {{status}} con éxito",
          deleted: "Flujo eliminado con éxito",
          duplicated: "Flujo duplicado con éxito",
          invalidZip: "Por favor, selecciona un archivo ZIP (.zip)",
          imported: "Flujo importado con éxito",
        },
      },
      floup: {
        page: {
          title: "Follow UP - Plantillas de Flujo",
          newTemplate: "Nuevo Template",
          editTemplate: "Editar Template",
          steps: "{{count}} pasos",
          active: "Activo",
          inactive: "Inactivo",
          tooltips: { edit: "Editar", duplicate: "Duplicar", delete: "Eliminar" },
          saveError: "Error al guardar el Follow UP. Verifica la consola para más detalles.",
          deleteError: "Error al eliminar el Follow UP. Verifica la consola para más detalles.",
          uploadError: "Error al subir el archivo. Verifica la consola para más detalles.",
          defaultName: "este floup",
          templateTypes: {
            client: { title: "Template para Clientes", description: "Flujo automatizado para clientes existentes", defaultMessage: "¡Hola! ¿Cómo podemos ayudarte hoy?" },
            lead: { title: "Template para Leads", description: "Flujo de nutrición para nuevos leads", defaultMessage: "¡Hola! ¡Bienvenido! Tenemos una oferta especial para ti." },
            custom: { title: "Template Personalizado", description: "Crea tu propio flujo con condiciones específicas" },
          },
          basicInfo: "Información Básica",
          templateName: "Nombre del Template",
          templateTypeLabel: "Tipo de Template",
          templateTypeOptions: { client: "Cliente", lead: "Lead", custom: "Personalizado" },
          description: "Descripción",
          triggerCondition: "Condición para Activación",
          triggerConditionHelp: "Define cuándo debe activarse este Follow UP. Una vez activado, todos los pasos se ejecutarán secuencialmente hasta que se cumplan las condiciones de parada.",
          condition: "Condición",
          conditionOptions: { queue: "Cola del sistema", tag: "Etiqueta del sistema", firstClientInteraction: "Primera interacción del cliente", firstAttendantInteraction: "Primera interacción del agente" },
          queue: "Cola",
          selectQueue: "Seleccionar cola",
          tag: "Etiqueta",
          selectTag: "Seleccionar etiqueta",
          conditionDescription: "Descripción de la condición",
          conditionDescriptionPlaceholder: "Ej: Cliente envió el primer mensaje",
          stopControls: "Controles de Parada del Flujo",
          stopConditions: {
            anyMessage: "1. Si el Contacto responde cualquier mensaje",
            keyword: "2. Si el Contacto responde una Palabra clave",
            keywordLabel: "Palabra clave",
            keywordPlaceholder: "Ej: PARAR, CANCELAR, SALIR",
            ticketClosed: "3. Si el Ticket es Cerrado",
          },
          stepsHeading: "Pasos del Flujo",
          addStep: "Agregar Paso",
          cancel: "Cancelar",
          saveTemplate: "Guardar Template",
          step: {
            title: "Paso {{order}}",
            emptyMessage: "Mensaje vacío",
            attachment: "Adjunto",
            message: "Mensaje",
            charsCount: "{{count}}/500 caracteres",
            value: "Valor",
            timeUnit: "Unidad de Tiempo",
            timeUnits: { minutes: "Minutos", hours: "Horas", days: "Días", weeks: "Semanas", months: "Meses", years: "Años" },
            sendAfter: "Enviar después de {{value}} {{unit}}",
            attachmentLink: "Adjunto/Link",
            linkOption: "Link",
            uploadOption: "Subir",
            pasteUrl: "Pega la URL aquí",
            removeLink: "Quitar link",
            removeMedia: "Quitar archivo",
            chooseFile: "Elegir Archivo",
            uploading: "Enviando {{fileName}}...",
            videoPlayerTitle: "Reproductor de Video",
            videoNotSupported: "Tu navegador no soporta el elemento de video.",
            removeStep: "Quitar Paso",
          },
          preview: {
            title: "Vista Previa del Mensaje",
            attachment: "Adjunto",
            hint: "El ícono de adjunto aparecerá aquí",
          },
          deleteDialog: {
            title: "Confirmar Eliminación",
            body: '¿Seguro que deseas eliminar el Follow UP "{{name}}"? Esta acción no se puede deshacer y todos los archivos asociados se eliminarán permanentemente.',
            cancel: "Cancelar",
            confirm: "Eliminar",
          },
        },
        selector: {
          stopSuccess: "Follow UP interrumpido con éxito",
          stopButton: "Detener Follow UP",
          nextSteps: "Próximos pasos:",
          active: "Activo",
          selectLabel: "Seleccionar Follow UP",
          chooseTemplate: "Elegir template...",
          infoTooltip: "Información sobre Follow UP",
          stageLabel: "{{name}} - Etapa {{current}} de {{total}}",
          nextRun: "Próxima ejecución: {{date}}",
          activeShort: "Follow UP activo",
          noneActive: "Ningún Follow UP activo",
          noneActiveHelper: "Este contacto no está en ningún Follow UP en este momento",
          infoDialog: {
            title: "Sobre el Sistema Follow UP",
            body1: "El <strong>Follow UP</strong> permite crear flujos de mensajes y asignarlos a un contacto o ticket para ejecución automática.",
            body2: "Selecciona un template activo para iniciar. Puedes interrumpirlo en cualquier momento.",
            close: "Entendido",
          },
        },
        dashboard: {
          title: "Dashboard de Follow UP por Etapas",
          refresh: "Actualizar",
          error: "Error",
          next: "Próximo: {{date}}",
          recentError: "⚠️ Error reciente",
          stage: "Etapa {{order}}",
          noMessage: "Sin mensaje",
          noContactsInStage: "Ningún contacto en esta etapa",
          selectLabel: "Follow UP",
          inactive: "(Inactivo)",
          stagesCount: "Etapas",
          contactsCount: "Contactos",
          search: "Buscar",
          channel: "Canal",
          allChannels: "Todos",
          selectFloup: "Selecciona un Follow UP para visualizar las etapas",
          noData: "No se encontraron datos para este Follow UP",
          noStages: "No se encontraron etapas",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      pendingTicketOverlay: {
        title: "Conversación Bloqueada",
        subtitle: "Este ticket está esperando ser aceptado. Aceptá la conversación para ver y responder los mensajes del cliente.",
        statusWaiting: "Estado: En Espera",
        defaultContactName: "Contacto",
        accepting: "Aceptando...",
        acceptConversation: "Aceptar Conversación",
        warning: "🚫 No podés ver los mensajes antes de aceptar el ticket",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        hideFilters: "Ocultar Filtros",
        showFilters: "Mostrar Filtros",
        satisfactionSurvey: "Encuesta de satisfacción",
        attendances: "Atenciones",
        errorFetchingTickets: "Error al buscar información de los tickets",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Detractores",
        },
      },
      reports: {
        title: "Reporte de Atenciones",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        preDeleteTitle: "Antes de eliminar",
        preDeleteBody: "¿Ya transferiste los tickets de esta conexión a otra? Si no, recomendamos transferirlos antes de eliminar.",
        preDeleteNo: "Aún no",
        preDeleteYes: "Sí, ya transferí",
        title: "Conexiones",
        waitConnection: "Espere... Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
          color: "Color",
          receiveComments: "Recibir Comentarios",
        },
        receiveComments: {
          enabled: "Recepción de comentarios habilitada",
          disabled: "Recepción de comentarios deshabilitada",
          tooltip: {
            enabled: "Los comentarios se están recibiendo. Haga clic para deshabilitar.",
            disabled: "Los comentarios no se están recibiendo. Haga clic para habilitar.",
          },
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
        buttons: {
          close: "Cerrar",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historico",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: "iniciou la atención.",
          access: "accesó el ticket.",
          transfered: "transferió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "regresó a la fila.",
          closed: "cerró el ticket",
          reopen: "abrió el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
          chatbot: "Chatbot",
          flowbuilder: "Flujo Predeterminado",
        },
        sections: {
          tokenIntegration: "Token para integración externa",
          flowWelcome: "Flujo de bienvenida",
          flowWelcomeSubtitle: "Este flujo se dispara solo para nuevos contactos, personas que no tienes en tu lista de contactos y que enviaron un mensaje.",
          flowDefault: "Flujo de respuesta predeterminado",
          flowDefaultSubtitle: "La respuesta predeterminada se envía con cualquier carácter diferente de una palabra clave. ¡ATENCIÓN! Se disparará si la atención ya está cerrada.",
          disabled: "Deshabilitado",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividade",
          prompt: "Prompt",
          triggerIntegrationOnClose:
            "Integración de activadores al cerrar un ticket",
          enableIntegration: "Activadore Integración",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        conversationFlows: "La conversación fluye",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        loading: "Cargando...",
        loadMore: "Cargar Más",
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Ultimo Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        tabs: {
          general: "General",
          aiModel: "IA y Modelo",
          messages: "Mensajes",
          voice: "Voz",
        },
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
          provider: "Proveedor",
          model: "Modelo",
          modelRecommended: "(Recomendado)",
          modelEconomic: "(Económico)",
          trainingLabel: "Entrenamiento / Prompt del Sistema",
          trainingPlaceholder: "Ej: Eres un asistente virtual de la empresa X. Tu función es atender clientes, resolver dudas sobre productos y servicios...",
          temperatureHelper: "0 = preciso, 1 = creativo",
          maxTokensHelper: "Tamaño máx. de la respuesta",
          maxMessagesHelper: "Contexto de memoria",
          greetingMessage: "Mensaje de Saludo Inicial",
          greetingPlaceholder: "Ej: ¡Hola {{firstName}}! 👋 Soy el asistente virtual de la empresa. ¿Cómo puedo ayudarte?",
          greetingHelper: "Primer mensaje enviado al cliente cuando la IA toma el control. Deja vacío para que la IA inicie directamente.",
          transferMessage: "Mensaje de Transferencia",
          transferPlaceholder: "Ej: ¡Entendido! Te voy a transferir con un agente humano. ¡Espera un momento! 😊",
          transferHelper: "Mensaje enviado cuando el cliente solicita hablar con un agente.",
          errorMessage: "Mensaje de Error",
          errorPlaceholder: "Ej: Disculpa, estoy teniendo dificultades técnicas en este momento. Intenta nuevamente más tarde.",
          errorHelper: "Mensaje enviado cuando ocurre un error en la IA.",
          transferKeywordsTitle: "🔑 Palabras Clave de Transferencia",
          transferKeywords: "Palabras Clave de Transferencia",
          transferKeywordsPlaceholder: "Ej: hablar con humano, quiero un agente, salir de la ia, ayúdame de verdad",
          transferKeywordsHelper: "Palabras o frases separadas por coma. Cuando el cliente escriba alguna de ellas, será transferido a un agente. Las palabras predeterminadas del sistema siguen activas.",
          voiceMode: "Modo de Respuesta",
          voiceText: "Texto",
          voiceKeyAzure: "Clave de Voz (Azure)",
          voiceRegionAzure: "Región de Voz (Azure)",
          voiceOnlyOpenAiWarning: "⚠️ La respuesta por voz solo funciona con el proveedor OpenAI. Con Gemini, la respuesta siempre será en texto.",
        },
        variables: {
          availableInPrompt: "💡 Variables disponibles en el prompt:",
          availableInMessages: "💡 Variables disponibles en los mensajes:",
          contactName: "Nombre del contacto",
          firstName: "Primer nombre",
          queueName: "Nombre de la fila",
          agentName: "Nombre del agente",
          currentDate: "Fecha actual",
          currentHour: "Hora actual",
          greeting: "Saludo (Buenos días...)",
        },
        validation: {
          tooShort: "¡Muy corto!",
          tooLong: "¡Muy largo!",
          required: "Obligatorio",
          promptRequired: "Describe el entrenamiento para la Inteligencia Artificial",
          voiceRequired: "Indica el modo de Voz",
          maxTokensRequired: "Indica el número máximo de tokens",
          temperatureRequired: "Indica la temperatura",
          apikeyRequired: "Indica la API Key",
          queueRequired: "Indica la fila",
          maxMessagesRequired: "Indica el número máximo de mensajes",
          missingQueue: "Indica el sector",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
        noPermission: "Esta empresa no tiene permiso para acceder a esta página. Te estamos redirigiendo.",
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
        wallet: "Cartera",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción invalida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
          showReturnQueueButton: "Mostrar botón de devolver a la fila",
          showTransferTicketButton: "Mostrar botón de transferir ticket",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel en Tiempo Real",
          allowConnections: "Permitir acciones en conexiones",
          showContacts: "Ver contactos",
          showCampaign: "Ver campañas",
          showFlow: "Ver automatizaciones",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Programa",
          edit: "Editar Programa",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          assinar: "Enviar Firma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programa",
        },
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para redirigir al carril",
          nextLaneId: "Carril",
          greetingMessageLane: "Mensaje de bienvenida del carril",
          mediaFiles: "Medios",
          rollbackLaneId: "Volver al carril después de reanudar la atención",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar menú de evaluación",
          edit: "Editar menú de evaluación",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre",
          message: "Mensaje de Evaluación",
          options: "Opciones de Evaluación",
          extraName: "Nombre de la opción",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿Quieres cerrar todos los tickets?",
        yes: "SI",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolvAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SI",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
          messageHidden: "Mensaje oculto",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      chatInternal: {
        new: "Nuevo grup",
        modal: {
          conversation: "Inicio",
          title: "Título",
          filterUsers: "Filtro por Usuarios",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        selectQueue: "Selecciona una fila",
        selectConnection: "Selecciona una Conexión",
        queueRequired: "Selecciona una fila",
        otherUser: "Otro usuario",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          birthdaySettings: "Config. Cumpleaños",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          reports: "Informes",
          management: "Gerencia",
          callHistorical: "Historial de Llamadas",
          automations: "Automatizaciones",
          campaignFlow: "Flujo de Campaña",
          conversationFlow: "Flujo de conversación",
          followUpTemplates: "Follow UP (Plantillas)",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
        ar: "Árabe",
        "pt-BR": "Portugués",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
        messageHidden: "Mensaje oculto",
        newMessage: "Nuevo mensaje de",
      },
      triggerFlowModal: {
        title: "Disparar Flujo",
        description:
          "Selecciona un flujo para ejecutar en este ticket. El ticket cambiará a estado 'chatbot' durante la ejecución.",
        selectFlow: "Elige un flujo",
        selectedFlow: "Flujo seleccionado",
        flowId: "ID del flujo",
        noFlows: "No se encontraron flujos activos",
        cancel: "Cancelar",
        trigger: "Disparar Flujo",
        triggering: "Disparando...",
        success: "¡Flujo disparado con éxito!",
        error: "Error al disparar el flujo",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "No hay",
        selectMessage: "Seleccionar Respuesta Rápida",
        hasMedia: "Con multimedia",
        global: "Global",
        noResultsFound: "No se encontraron respuestas rápidas para tu búsqueda",
        noQuickMessages: "No hay respuestas rápidas disponibles",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Admin",
          tags: "Lanes",
        },
      },
      templatePreview: {
        fillVariables: "Completa las variables para ver el mensaje personalizado:",
        variable: "Variable",
        variablePlaceholder: "Ej: Nombre del contacto",
        hideFields: "Ocultar campos",
        editVariables: "Editar variables",
        image: "Imagen",
        video: "Video",
        document: "Documento",
        attachAbove: "Adjunta {{type}} arriba",
      },
      campaigns: {
        title: "Campañas",
        noPermission: "Esta empresa no tiene permiso para acceder a esta página. Serás redirigido.",
        searchPlaceholder: "Búsqueda",
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contatos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Estado",
          scheduledAt: "Programada",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
          recurrence: "Recurrencia",
          nextExecution: "Próxima Ejecución",
          finished: "Finalizada",
          single: "Única",
          listRemoved: "Lista eliminada",
          connectionRemoved: "Eliminada",
          notCompleted: "No completada",
          totalCount: "Total: {{count}} campaña(s)",
          rowsPerPage: "Filas por página:",
        },
        status: {
          INATIVA: "Inactiva",
          PROGRAMADA: "Programada",
          EM_ANDAMENTO: "En Progreso",
          CANCELADA: "Cancelada",
          FINALIZADA: "Finalizada",
        },
        recurrenceTypes: {
          DIARIA: "Diaria",
          SEMANAL: "Semanal",
          QUINZENAL: "Quincenal",
          MENSAL: "Mensual",
        },
        tooltips: {
          recurring: "Campaña Recurrente",
          stop: "Detener Campaña",
          restart: "Reiniciar Campaña",
          stopRecurrence: "Detener Recurrencia",
          report: "Reporte",
          edit: "Editar",
          delete: "Eliminar",
        },
        filters: {
          status: "Estado",
          recurrence: "Recurrencia",
          all: "Todos",
          withRecurrence: "Con recurrencia",
          withoutRecurrence: "Sin recurrencia",
        },
        confirmModal: {
          stopRecurrenceTitle: "Detener Recurrencia",
          stopRecurrenceBody: "¿Estás seguro de que deseas detener la recurrencia de esta campaña? La campaña actual continuará ejecutándose, pero no habrá más ejecuciones futuras.",
        },
        toasts: {
          recurrenceStopped: "Recurrencia detenida exitosamente",
          total: "Total: {{count}} campaña(s)",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
          tabs: {
            campaign: "Campaña",
            contactLists: "📋 Listas de Contactos",
            settings: "⚙️ Configuraciones",
          },
          recurrence: {
            sectionTitle: "Configuración de Recurrencia",
            enable: "Habilitar recurrencia",
            typeLabel: "Tipo de Recurrencia",
            intervalLabel: "Intervalo",
            daysOfWeek: "Días de la Semana",
            dayOfMonth: "Día del Mes",
            dayOfMonthHint: "Día específico del mes (1-31)",
            endDate: "Fecha Final (opcional)",
            endDateHint: "Deja vacío para recurrencia infinita",
            maxExecutions: "Máximo de Ejecuciones (opcional)",
            maxExecutionsHint: "Deja vacío para recurrencia infinita",
            showPreview: "Ver Próximas Ejecuciones",
            hidePreview: "Ocultar Próximas Ejecuciones",
            previewTitle: "Próximas 5 Ejecuciones:",
            executionLabel: "Ejecución",
            days: {
              sunday: "Domingo",
              monday: "Lunes",
              tuesday: "Martes",
              wednesday: "Miércoles",
              thursday: "Jueves",
              friday: "Viernes",
              saturday: "Sábado",
            },
            types: {
              minutely: "Por Minuto",
              hourly: "Por Hora",
              daily: "Diario",
              weekly: "Semanal",
              biweekly: "Quincenal",
              monthly: "Mensual",
              yearly: "Anual",
            },
            intervalHint: {
              minutely: "minuto(s)",
              hourly: "hora(s)",
              daily: "día(s)",
              weekly: "semana(s)",
              biweekly: "quincena(s)",
              monthly: "mes(es)",
              yearly: "año(s)",
            },
          },
          contactSection: {
            title: "📋 Lista de Contactos de la Campaña",
            subtitle: "Selecciona una lista creada en la pestaña",
            subtitleTab: "📋 Listas de Contactos",
            subtitleEnd: ". La lista define quién recibirá los mensajes de esta campaña.",
            selectLabel: "Lista de Contactos",
            noList: "Ninguna lista seleccionada",
            tagLabel: "Filtrar por Tag (opcional)",
            noTag: "Sin filtro de tag",
            changeList: "Cambiar lista → Ir a Listas de Contactos",
            createList: "+ Crear o seleccionar lista en la pestaña Listas de Contactos",
            contacts: "contactos",
          },
          message: {
            sectionTitle: "Mensaje de la Campaña",
            attachMedia: "Adjuntar Media",
            officialApiNotice: "Para API Oficial, utiliza el template seleccionado. El campo de mensaje y adjunto no están disponibles.",
            selectApprovedTemplate: "Selecciona un template aprobado para campañas vía API Oficial.",
            noApprovedTemplate: "No se encontró ningún template aprobado. Crea un template antes de enviar.",
            officialRequired: "Obligatorio para API Oficial. Los mensajes sin template fallan fuera de la ventana de 24h.",
            previewTitle: "Vista previa del mensaje",
            previewSubtitle: "Visualiza cómo aparecerá el mensaje en WhatsApp",
            previewContact: "Contacto",
            previewEmpty: "Escribe un mensaje para\nver la vista previa aquí",
            inputPlaceholder: "Escribe un mensaje",
            variablesHint: "Variables disponibles",
          },
          shootingSettings: {
            title: "Intervalos de Disparo",
            subtitle: "Configura los intervalos de tiempo entre los disparos de esta campaña para evitar bloqueos.",
            antiBan: "Anti-Ban",
            antiBanSubtitle: "Humaniza el disparo para reducir el riesgo de bloqueo",
            pauseEvery: "Pausa extra cada N msgs",
            pauseDuration: "Duración de la pausa extra",
            disabled: "Deshabilitado",
            everyN: "Cada {{n}} mensajes",
            saveSuccess: "¡Configuraciones guardadas exitosamente!",
            jitter: "Variación aleatoria (jitter)",
            seconds: "segundos",
            minute: "1 minuto",
            minutes: "{{n}} minutos",
          },
          variables: {
            name: "Nombre",
            number: "Número",
            email: "Email",
            greeting: "Saludo",
            protocol: "Protocolo",
            firstName: "Primer Nombre",
            agent: "Agente",
          },
          templateLabel: "Template *",
          officialApiLabel: "API Oficial",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignContactSelector: {
        contacts: "contactos",
        excelTemplate: "Modelo Excel",
        importExcel: "Importar Excel",
        importContacts: "Importar Contactos",
        searchContact: "Buscar contacto...",
        searchByNameOrNumber: "Buscar por nombre o número...",
        searchList: "Buscar lista...",
        searchSystemContacts: "Buscar Contactos del Sistema",
        noContactsInList: "Ningún contacto en esta lista aún.",
        importViaExcelOrWhatsApp: "Importe vía Excel o desde WhatsApp usando los botones de arriba.",
        name: "Nombre",
        number: "Número",
        email: "Email",
        loadMore: "Cargar más",
        listSelectedForCampaign: "✓ Lista seleccionada para esta campaña",
        selectThisListForCampaign: "Seleccionar esta lista para la campaña",
        backToCampaign: "Volver a la Campaña →",
        newContactList: "Nueva Lista de Contactos",
        newListExcel: "Nueva Lista + Excel",
        simpleList: "Lista Simple",
        contactLists: "Listas de Contactos",
        headerSubtitle: "Crea listas, importa contactos y selecciona la lista que se usará en esta campaña.",
        selectedListLabel: "Lista seleccionada",
        contactsWillBeUsed: "contactos — esta lista será usada en la campaña",
        remove: "Remover",
        noListCreated: "Ninguna lista creada aún.",
        clickNewListToStart: "Haz clic en \"Nueva Lista\" para comenzar.",
        selectedBadge: "Seleccionada",
        steps: {
          nameList: "Nombrar lista",
          importContacts: "Importar contactos",
        },
        nameListDescription: "Asigna un nombre para identificar esta lista de contactos.",
        listNameLabel: "Nombre de la lista",
        nameMinChars: "El nombre debe tener al menos 2 caracteres.",
        listNamePlaceholder: "Ej: Clientes VIP, Prospectos Noviembre...",
        characters: "caracteres",
        listCreatedImportOptional: "Lista \"{{name}}\" creada! Ahora importa los contactos (opcional).",
        dragExcelOrClick: "Arrastra el Excel aquí o haz clic para seleccionar",
        acceptedFormats: "Formatos aceptados: .xls, .xlsx",
        downloadTemplate: "📥 Descargar planilla modelo (.xlsx)",
        close: "Cerrar",
        cancel: "Cancelar",
        skipImport: "Omitir importación",
        creating: "Creando...",
        createList: "Crear Lista →",
        sending: "Enviando...",
        selected: "seleccionado(s)",
        addingToList: "Agregando a la lista",
        filterByTag: "Filtrar por tag:",
        clear: "Limpiar",
        loadingTags: "Cargando tags...",
        noTagsAvailable: "Ninguna tag disponible.",
        selectAll: "Seleccionar todos",
        displayed: "mostrados",
        noContactFound: "Ningún contacto encontrado.",
        trySearchOther: "Intenta buscar por otro nombre o número.",
        adding: "Agregando...",
        addToList: "Agregar a la lista",
        confirmDeleteList: "¿Eliminar la lista \"{{name}}\"?",
        tooltips: {
          alreadySelected: "Lista ya seleccionada",
          selectForCampaign: "Seleccionar para la campaña",
          searchSystemContacts: "Buscar contactos del sistema para esta lista",
          editList: "Editar lista",
          deleteList: "Eliminar lista",
        },
        toasts: {
          contactsAdded: "{{count}} contacto(s) agregado(s) a la lista \"{{name}}\"!",
          listRemoved: "Lista removida con éxito",
          importStarted: "¡Importación iniciada! Los contactos se cargarán pronto.",
          selectWhatsAppFirst: "Selecciona una conexión WhatsApp en la campaña antes de importar.",
          whatsappImported: "¡Contactos de WhatsApp importados con éxito!",
          listCreated: "¡Lista \"{{name}}\" creada con éxito!",
          invalidFormat: "Formato inválido. Use solo archivos .xls o .xlsx",
          fileSent: "¡Archivo enviado! Los contactos se cargarán pronto.",
          listSelectedSuccess: "¡Lista \"{{name}}\" seleccionada para la campaña!",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        processed: "Procesados",
        failed: "Fallidos",
        pending: "Pendientes",
        of: "de",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
        fetchError: "Error al obtener datos del reporte",
        backButton: "Volver",
        deliveryStatus: "Estado de Entrega",
        messagesSent: "Mensajes Enviados",
        uniqueRecipients: "Destinatarios Únicos",
        messagesDelivered: "Mensajes Entregados",
        whatsappConnection: "Conexión WhatsApp",
        notSpecified: "No especificado",
        tagUsed: "Tag Utilizada",
        notScheduled: "No programado",
        notCompleted: "No completado",
        messageDetails: "Detalles de los Mensajes",
        exportExcel: "Exportar Excel",
        recipient: "Destinatario",
        message: "Mensaje",
        sentAt: "Enviado en",
        deliveredAt: "Entregado en",
        chartDelivered: "Entregados",
        chartPending: "Pendientes",
        chartFailed: "Fallidos",
        statusDelivered: "Entregado",
        statusPending: "Pendiente",
        statusFailed: "Fallido",
        statusUnknown: "Desconocido",
        loading: "Cargando...",
        noMessagesFound: "No se encontraron mensajes",
        rowsPerPage: "Filas por página:",
        group: "Grupo",
        excelGenerating: "Generando reporte Excel, espere...",
        excelLoadingData: "Cargando datos...",
        excelNoData: "No se encontraron datos para exportar",
        excelSuccess: "¡Reporte Excel generado con éxito!",
        excelError: "Error al generar reporte Excel",
        shippingLoadError: "Error al cargar datos de envío",
        excelReportTitle: "Reporte de Campaña",
        excelCampaignLabel: "Campaña:",
        excelDateLabel: "Fecha de Generación:",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      campaignsConfig: {
        title: "Configuraciones de Campañas",
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
          generateInvoice: "Generar Factura",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
          public: "Público",
          trial: "Prueba",
          trialDays: "Días de Prueba",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Programas",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMMAS",
        search: "BUSCAR",
        seeTicket: "VER BILLETE",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Abierto(s)",
        backToKanban: "VOLVER A KANBAN",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            transferredTicketStatus:
              "Estado del ticket al transferir con usuario",
            copyContactPrefix: "Prefijo para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_",
            open: "Abierto",
            pending: "Pendiente",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "Finalizando la atención al cliente!",
          dialogRatingCancel: "Cerrar CON Mensaje de Despedida",
          dialogRatingSuccess: "Cerrar y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Cerrar SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          amount: "Valor de prospección",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar integración",
            disableIntegration: "Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "Opps! Debes asignar una tag antes de cerrar el ticket.",
            greetingAcceptedMessage:
              "Debes configurar un mensaje de saludo al aceptar el ticket.",
            newTicket: "Crear Nuevo Ticket",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderOpen:
          "Entre como un mensaje o con / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        placeholderPending:
          "Escribe tu mensaje interno (ticket en espera)...",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privada",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
          scheduledDate: "Fecha del Programa",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Cerrar sin despedida",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        windowExpiredPlaceholder: "⚠️ Ventana de 24h expirada - Recomendado enviar plantilla",
        windowExpiredBanner: "Ventana de 24h Expirada:",
        windowExpiredBannerDetail: "Recomendamos enviar una plantilla, pero también puedes escribir normalmente.",
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
          triggerFlow: "Disparar Flujo",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
          template: "Plantilla Meta",
        },
        pendingAlert: {
          title: "Ticket en Espera:",
          description: "En este momento solo se permiten mensajes internos.",
        },
        flowAlert: {
          title: "Flujo en Ejecución:",
          description: "Campo de mensaje temporalmente deshabilitado.",
        },
        formatMenu: {
          bold: "Negrita",
          italic: "Cursiva",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista Numerada",
          bulletList: "Lista con Viñetas",
          quote: "Cita",
          clearFormat: "Limpiar Formato",
        },
        ghostMention: {
          tooltip: "Mención Fantasma (notifica a todos sin mostrar @)",
          label: "Mención Fantasma",
        },
        signature: {
          label: "Firma",
        },
        comments: {
          tooltip: "Habilitar/Deshabilitar Comentarios",
          label: "Comentarios",
        },
        quickAnswers: {
          hintNavigate: "{{count}} respuestas • usa ↑↓ para navegar",
          hintScroll: "{{count}} respuestas • desplázate para ver más",
        },
        errors: {
          ticketIdNotFound: "Error: ID del ticket no encontrado",
        },
        internalMessageLabel: "Mensaje Interno",
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "la test del envio",
      },
      recurrenceSection: {
        title: "Recurrence",
        description:
          "You can choose to send the message recurrently and select the interval. If it is a one-time message, do not change anything in this section.",
        labelInterval: "Interval",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months",
          minutes: "Minutes",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha de Vencimiento",
        status: "Estado",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
        connections: "Conexiones",
        newCampaign: "Nueva Campaña",
        nameNotDefined: "Nombre no definido",
        phrasesConfigured: "{{count}} frase(s) configurada(s)",
        active: "Activo",
        inactive: "Inactivo",
        editCampaignTooltip: "Editar campaña",
        deleteCampaignTooltip: "Eliminar campaña",
        noCampaignsFound: "No se encontraron campañas",
        noCampaignsHelper: 'Haz clic en "Nueva Campaña" para crear tu primera campaña de flujo',
        noConnection: "Ninguna conexión",
        moreConnections: "{{count}} conexión(es) más",
        toast: {
          deleted: "Campaña eliminada con éxito",
          errorLoadingFlows: "Error al cargar flujos",
          errorLoadingConnections: "Error al cargar conexiones",
          errorLoadingCampaign: "Error al cargar datos de la campaña",
          flowNotFound: "Flujo seleccionado no encontrado",
          saveError: "Error al guardar campaña",
          fillRequiredFields: "Por favor, completa todos los campos obligatorios",
          updated: "¡Campaña actualizada con éxito!",
          created: "¡Campaña creada con éxito!",
        },
        campaignNameLabel: "Nombre de la campaña",
        selectFlowLabel: "Selecciona un flujo",
        multiple: "(Múltiples)",
        whatsappConnectionsLabel: "Conexiones de WhatsApp",
        connectionsSelectedTitle: "{{count}} conexión(es) seleccionada(s):",
        connectionsSelectedDescription: "La campaña se ejecutará cuando cualquiera de estas conexiones reciba mensajes que coincidan con las frases configuradas.",
        filterByTag: "Filtrar por Etiqueta del Contacto",
        optional: "(opcional)",
        filterByTagDescription: "Si se selecciona(n), el flujo solo se disparará para contactos que tengan al menos una de estas etiquetas en la atención.",
        tagsOptionalLabel: "Etiquetas (opcional)",
        tagFilterActive: "🏷️ Filtro activo: El flujo solo se disparará para contactos que tengan al menos una de las {{count}} etiqueta(s) seleccionada(s).",
        keywordsTitle: "Palabras clave que disparan el flujo",
        orLogicInfo: "🔀 Lógica O: El flujo se disparará si el contacto envía cualquiera de las palabras/frases a continuación.",
        exactPartialInfo: "Exacta: mensaje idéntico.  |  Parcial: palabra contenida en cualquier parte del mensaje.",
        or: "O",
        phraseLabel: "Palabra/frase {{index}}",
        phrasePlaceholder: "Ej: hola, buenas, quiero cotización...",
        type: "Tipo",
        exact: "Exacta",
        partial: "Parcial",
        addPhraseButton: "+ Agregar otra palabra/frase (O)",
        saving: "Guardando...",
        validation: {
          nameRequired: "El nombre es obligatorio",
          flowRequired: "El flujo es obligatorio",
          connectionRequired: "Debes seleccionar al menos una conexión",
          fieldRequired: "Campo obligatorio",
        },
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "Nuevo",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Group Name",
          create: "Create",
          edit: "Editar",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",

        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema"
        }
      },
    },
  },
};

export { messages };
